export const SideBar = ({ children, style, id }) => {

    return (
        <div id={id} className='sidebar'>
            <div  style={style}>
                {children}
            </div>
        </div>
    )
}